export const ctiaSupportEmail = "support@ctiacertification.org";

export const getRequestMailtoInfo = ({ tn, modelName, vendor }) => {
  return {
    tn,
    modelName,
    vendor
  };
};
